'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var deviceContents = ["top-bar", "sleep", "volume", "camera", "sensor", "speaker", "screen", "home", "bottom-bar"];

var availableDevices = [{
  deviceName: "iphone6",
  content: [].concat(deviceContents),
  width: 423,
  height: 887
}, {
  deviceName: "iphone6plus",
  content: [].concat(deviceContents),
  width: 466,
  height: 960
}, {
  deviceName: "iphone5s",
  content: [].concat(deviceContents),
  width: 364,
  height: 778
}, {
  deviceName: "iphone5c",
  content: [].concat(deviceContents),
  width: 364,
  height: 778
}, {
  deviceName: "ipad",
  content: ["camera", "screen", "home"],
  width: 626,
  height: 948
}, {
  deviceName: "iphone4s",
  content: [].concat(deviceContents),
  width: 374,
  height: 738
}, {
  deviceName: "nexus5",
  content: ["top-bar", "sleep", "volume", "camera", "screen"],
  width: 350,
  height: 668
}, {
  deviceName: "s5",
  content: ["top-bar", "sleep", "camera", "sensor", "speaker", "screen", "home"],
  width: 356,
  height: 668
}, {
  deviceName: "htc-one",
  content: ["top-bar", "camera", "sensor", "speaker", "screen"],
  width: 370,
  height: 740
}, {
  deviceName: "macbook",
  content: ["top-bar", "camera", "screen", "bottom-bar"],
  width: 1048,
  height: 720
}];

var MarvelDevices = function (_Component) {
  _inherits(MarvelDevices, _Component);

  function MarvelDevices(props) {
    _classCallCheck(this, MarvelDevices);

    var _this = _possibleConstructorReturn(this, (MarvelDevices.__proto__ || Object.getPrototypeOf(MarvelDevices)).call(this, props));

    _this.createDeviceDivs = _this.createDeviceDivs.bind(_this);
    return _this;
  }

  _createClass(MarvelDevices, [{
    key: 'createDeviceDivs',
    value: function createDeviceDivs(props) {
      var deviceName = props.deviceName,
          color = props.color,
          orientation = props.orientation,
          children = props.children,
          transform = props.transform;

      var _availableDevices$fil = availableDevices.filter(function (eachDevice) {
        return eachDevice.deviceName === deviceName;
      }),
          _availableDevices$fil2 = _slicedToArray(_availableDevices$fil, 1),
          selectedDevice = _availableDevices$fil2[0];

      var newDimension = function newDimension(value) {
        return value * transform;
      };

      //noinspection JSSuspiciousNameCombination
      var Div = orientation !== "landscape" ? {
        width: newDimension(selectedDevice.width),
        height: newDimension(selectedDevice.height)

      } : {
        width: newDimension(selectedDevice.height),
        height: newDimension(selectedDevice.width)
      };

      var divs = selectedDevice.content.map(function (each, index) {
        return each === "screen" ? _react2.default.createElement(
          'div',
          {
            className: each,
            key: index,
            style: { overflow: 'hidden' }
          },
          _react2.default.createElement(
            'div',
            {
              style: { position: 'absolute' }
            },
            children
          )
        ) : _react2.default.createElement('div', {
          className: each,
          key: index
        });
      });

      return _react2.default.createElement(
        'div',
        { style: { width: Div.width, height: Div.height } },
        _react2.default.createElement(
          'div',
          {
            className: 'marvel-device\n                             ' + deviceName + '\n                             ' + color + '\n                             ' + orientation,
            style: { transform: 'scale(' + transform + ')', transformOrigin: 'top left' }
          },
          divs
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'marvel-device-wrapper' },
        this.createDeviceDivs(this.props)
      );
    }
  }]);

  return MarvelDevices;
}(_react.Component);

MarvelDevices.defaultProps = {
  deviceName: "macbook",
  color: "",
  orientation: "",
  transform: 1
};

MarvelDevices.PropTypes = {
  deviceName: _propTypes2.default.text,
  color: _propTypes2.default.text,
  orientation: _propTypes2.default.text,
  children: _propTypes2.default.node,
  transform: _propTypes2.default.number
};

exports.default = MarvelDevices;